import styles from './MessageLoader.module.scss'

function MessageLoader() {
  return (
    <div className={styles.messageLoaderWrapper}>
      <div className={styles.messageLoader} />
    </div>
  )
}

export default MessageLoader
